// Resolves a joybird fabric selection to whatever upholstery `code` Cylindo currently expects
// for this product. Cylindo's migration to SKU-shaped codes (CON-8166) is in flight per product
// family, so options on a single product may be on new SKU codes or legacy uppercase-name codes
// at any given time. Try SKU match → name match → uppercase fallback.
const resolveCylindoUpholsteryCode = ({
  jbSku,
  jbName,
  cylindoOptions,
} = {}) => {
  if (!Array.isArray(cylindoOptions) || cylindoOptions.length === 0) {
    return null;
  }

  const normalizedSku = (jbSku || '').replace(/^-/, '').trim();
  if (normalizedSku) {
    const bySku = cylindoOptions.find(opt => opt.code === normalizedSku);
    if (bySku) return bySku.code;
  }

  const normalizedName = (jbName || '').trim();
  if (normalizedName) {
    const lowerName = normalizedName.toLowerCase();
    const byName = cylindoOptions.find(
      opt => (opt.name || '').trim().toLowerCase() === lowerName
    );
    if (byName) return byName.code;
  }

  // Safety net for stale /configuration: match on Cylindo's legacy code shape (uppercased display name).
  const legacyUppercaseCode = normalizedName.replace(/™/g, '').toUpperCase();
  if (legacyUppercaseCode) {
    const byLegacyUppercase = cylindoOptions.find(
      opt => (opt.code || '').toUpperCase() === legacyUppercaseCode
    );
    if (byLegacyUppercase) return byLegacyUppercase.code;
  }

  return null;
};

export default resolveCylindoUpholsteryCode;
